import { lookupMeterIconKey, type MeterIconKey, resolveMeterIconKey } from "@next-platform/client-common-core/rulebook/meterIconKeys";
import { IconVariants } from "@next-platform/client-common-spicy-ui";
import type { MeterType } from "@next-platform/packages-ts-types";

/** Meter icon keys → spicy-ui icons, shared by the Studio picker and the chat HUD. */
const METER_ICON_VARIANTS: ReadonlyMap<MeterIconKey, IconVariants> = new Map<MeterIconKey, IconVariants>([
  ["heart", IconVariants.FAVORITE],
  ["shield", IconVariants.SHIELD_CHECK],
  ["shield_check", IconVariants.SHIELD_CHECK],
  ["search", IconVariants.SEARCH],
  ["flame", IconVariants.FLAME],
  ["spark", IconVariants.SPARKLE],
  ["sparkle", IconVariants.SPARKLES],
  ["flag", IconVariants.FLAG],
  ["coin", IconVariants.COINS],
  ["coins", IconVariants.COINS],
  ["dice", IconVariants.DICES],
  ["star", IconVariants.STAR],
  ["bolt", IconVariants.ZAP],
  ["gem", IconVariants.GEM],
  ["moon", IconVariants.MOON],
  ["sun", IconVariants.SUN],
  ["skull", IconVariants.SKULL],
  ["drop", IconVariants.DROPLET],
  ["key", IconVariants.KEY],
  ["crown", IconVariants.CROWN],
  ["eye", IconVariants.EYE],
  ["book", IconVariants.BOOK],
  ["sword", IconVariants.SWORD],
  ["leaf", IconVariants.LEAF],
  ["music", IconVariants.MUSIC],
  ["target", IconVariants.TARGET],
  ["brain", IconVariants.BRAIN],
  ["clock", IconVariants.CLOCK],
  ["coffee", IconVariants.COFFEE],
  ["info", IconVariants.INFO],
]);

/** The spicy-ui icon for a meter `icon` name, or `undefined` for unknown/empty names. */
export const lookupMeterIcon = (iconName: string | undefined): IconVariants | undefined => {
  const iconKey = lookupMeterIconKey(iconName);
  return iconKey ? METER_ICON_VARIANTS.get(iconKey) : undefined;
};

/** Resolve a Rulebook meter's icon, using meter-type fallbacks where needed. */
export const resolveMeterIcon = ({ icon, meterType }: { icon?: string; meterType: MeterType }): IconVariants =>
  METER_ICON_VARIANTS.get(resolveMeterIconKey({ icon, meterType })) ?? IconVariants.SPARKLE;
